import * as goodsList from '../services/goodsList';

export default {
  namespace: 'goodsList',

  state: {
    userInfo: null,
    memberPageList: null,
    addMember: null,
    levels: [],
  },

  effects: {
    //商品管理一览列表
    *getGoodsList({ payload: { values } }, { call, put }) {
      const response = yield call(goodsList.getGoodsList, values);
      yield put({
        type: 'save',
        payload: {
          goodsList: response?.data,
        },
      });
    },

    //改变商品状态
    *changeGoodStatus({ payload: { values }, callback }, { call, put }) {
      const response = yield call(goodsList.changeGoodStatus, values);
      yield put({
        type: 'save',
        payload: {},
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },

    //删除商品
    *deleteGood({ payload: { values }, callback }, { call, put }) {
      const response = yield call(goodsList.deleteGood, values);
      yield put({
        type: 'save',
        payload: {},
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
